<template>
  <div class="login-container">
    <div class="login-box">
      <h2>客户登录</h2>
      <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" @keyup.enter.native="handleLogin">
        <el-form-item prop="phone">
          <el-input 
            v-model="loginForm.phone" 
            prefix-icon="el-icon-user" 
            placeholder="请输入手机号码"
            @keyup.enter.native="handleLogin">
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input 
            v-model="loginForm.password" 
            prefix-icon="el-icon-lock" 
            placeholder="请输入密码" 
            show-password
            @keyup.enter.native="handleLogin">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button 
            :loading="loading" 
            type="warning" 
            class="login-button" 
            @click="handleLogin">
            登录
          </el-button>
        </el-form-item>
      </el-form>
      <div class="register-link">
        还没有账号？<el-link type="primary" @click="goToRegister">立即注册</el-link>
      </div>
    </div>
  </div>
</template>

<script>
import adminApi from '../../api/adminApi'
import { setTokenByRole } from '@/utils/request'

export default {
  name: 'CustomerLogin',
  data() {
    return {
      loginForm: {
        phone: '',
        password: ''
      },
      loginRules: {
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少6个字符', trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          adminApi.customerLogin(this.loginForm)
            .then(res => {
              this.$message.success('登录成功')
              // 存储token和用户信息
              localStorage.setItem('currentRole', 'customer')
              localStorage.setItem('userRole', 'customer')
              // 使用命名空间方式存储token
              setTokenByRole(res.token || '', 'customer')
              localStorage.setItem('token', res.token || '') // 保留兼容性
              localStorage.setItem('userInfo', JSON.stringify(res))
              // 登录成功后跳转到客户端首页
              this.$router.push('/customer/orders/all')
            })
            .catch(err => {
              this.$message.error(err.message || '登录失败，请检查账号密码')
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          return false
        }
      })
    },
    goToRegister() {
      this.$router.push('/customer/register')
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f0f2f5;
}
.login-box {
  width: 400px;
  padding: 30px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.login-box h2 {
  text-align: center;
  margin-bottom: 30px;
  color: #E6A23C;
}
.login-button {
  width: 100%;
}
.register-link {
  text-align: center;
  margin-top: 15px;
}
</style> 